export const environment = {
  production: false,
  URL_BASE: 'https://api-test.lifeinsurtech.com.ar/autogestion',
  HTTP_TIME_OUT: 60000,
  RETRY: 0
}
